export default {
  activateLandingPageTitle: 'Evenementen',
  activateProductCardTitle: 'Evenementen',
  activateProductPageTitle: 'Boek evenementen',
  allProductsLandingPageTitle: 'Boek unieke ervaringen',
  apply: 'Toepassen',
  buyTickets: 'Koop tickets',
  cancel: 'Annuleren',
  clear: 'Wissen',
  clearFilters: 'Filters wissen',
  discoverExperiences: 'Ontdek ervaringen',
  exclusive: 'Exclusief',
  experience: 'ervaring',
  experiencePhotoOfListing:
    'Ervaringsfoto {{photoNumber}} van vermelding {{listingTitle}}',
  experiences: 'ervaringen',
  filterExperiences: 'Ervaringen filteren',
  fromListingCard: 'Vanaf',
  hostedBy: 'Gehost door',
  hostLandingPageTitle: 'Lokale ervaringen',
  hostProductCardTitle: 'Lokale ervaringen',
  hostProductPageTitle: 'Boek lokale ervaringen',
  landingPageTitle: 'Boek unieke ervaringen',
  mainLandingPageTitle: 'Alle ervaringen',
  more: 'Meer',
  noExperiencesFound: 'Geen ervaringen gevonden',
  noExperiencesFoundFor: 'Geen ervaringen gevonden voor',
  experiencesFoundCount: '{{count}} ervaringen gevonden',
  profileImageOfHost: 'Profielafbeelding van gastheer {{hostName}}',
  reserve: 'Reserveren',
  reserveLandingPageTitle: 'Activiteiten en voorzieningen',
  reserveProductCardTitle: 'Activiteiten',
  reserveProductPageTitle: 'Boek activiteiten en voorzieningen',
  resultsPageTitle: 'Boek ervaringen en activiteiten',
};
